"use client";

import type React from "react";
import { Card } from "../ui/card-animated";

import type { FormData } from "./types";
import { Select } from "@/shared/components/organisms/Select";
import { Input } from "@/shared/components/atoms/Input";

interface PersonalInfoSectionProps {
  formData: FormData;
  handleChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => void;
}

export const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({
  formData,
  handleChange,
}) => {
  return (
    <Card title="Información Personal" delay={0}>
      <div className="space-y-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Nombre completo"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
          <Input
            label="Correo Electrónico"
            name="email"
            value={formData.email}
            onChange={handleChange}
            type="email"
            required
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium leading-6 text-gray-600">
              Sexo
            </label>
            <Select
              name="sex"
              setSelected={(option) =>
                handleChange({
                  target: {
                    name: "sex",
                    value: option,
                  },
                })
              }
              selected={formData.sex}
              required
              options={[
                { id: "1", name: "Hombre" },
                { id: "2", name: "Mujer" },
              ]}
            />
          </div>
          <Input
            label="Fecha de Nacimiento"
            name="birthday"
            value={formData.birthday}
            onChange={handleChange}
            type="date"
            required
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Teléfono"
            name="phone"
            type="number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <Input
            label="Número de Identidad/Cédula"
            name="identity_number"
            type="number"
            value={formData.identity_number}
            onChange={handleChange}
            required
          />
        </div>
      </div>
    </Card>
  );
};
